export default __webpack_public_path__ + "static/media/9.ab141673.mp3";